// extracted by mini-css-extract-plugin
export default {"textarea":"styles__textarea--7vkB3","disabled":"styles__disabled--uyZ9E"};